module.exports = __webpack_public_path__ + "static/media/DSC_0060.cab805b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0060.jpg
// module id = 550
// module chunks = 0